import {useCallback, useContext, useEffect, useState} from "react";
import {EngageContext} from "engage-client/context";

export enum TimeUnit {
	MILLISECONDS,
	SECONDS
}

export function useCountdown(start:number, duration:number, pause?:number, returnUnit:TimeUnit = TimeUnit.SECONDS):number {
	const {syncedTime} = useContext(EngageContext);
	const calculateRemainingTime = useCallback(() => {
		let elapsed = (pause ? pause : syncedTime()) - start;
		if(elapsed > duration) {
			return 0;
		} else {
			if(returnUnit === TimeUnit.MILLISECONDS) {
				return 	duration - elapsed;
			} else {
				return Math.ceil((duration - elapsed) / 1000);
			}
		}
	}, [duration, pause, returnUnit, start, syncedTime]);

	const [timeRemaining, setTimeRemaining] = useState(calculateRemainingTime());
	useEffect(() => {
		let interval = setInterval(() => {
			let timeRemaining = calculateRemainingTime();
			if(timeRemaining === 0) {
				clearInterval(interval);
			}
			setTimeRemaining(timeRemaining);
		}, returnUnit === TimeUnit.SECONDS ? 50 : 16);
		return () => clearInterval(interval);
	}, [start, duration, pause, returnUnit, calculateRemainingTime]);
	return timeRemaining;
}